import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryTypes } from '@webapp/models/enums/BudgetCategoryType'
import { type BudgetCategoryTypeOption } from '../BudgetCategoryTypeSelect'
import messages from '../messages'

export const useBudgetCategoryTypeOptions = () => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  const budgetCategoryTypeOptions: BudgetCategoryTypeOption[] = [
    {
      label: intl.formatMessage(
        isFlexibleSpendTrackingEnabled
          ? messages.allBudgets
          : messages.allBudgetCategories
      ),
      value: BudgetCategoryTypes.ALL,
    },
    {
      label: intl.formatMessage(messages.onlySourceOfTruthBudgetCategories),
      value: BudgetCategoryTypes.INCLUDE_SOURCE_OF_TRUTH,
    },
    {
      label: intl.formatMessage(messages.excludeSourceOfTruthBudgetCategories),
      value: BudgetCategoryTypes.EXCLUDE_SOURCE_OF_TRUTH,
    },
  ]

  return budgetCategoryTypeOptions
}
